<p-editor
  #editorRef
  [ngClass]="ngClass"
  [ngModel]="value"
  [modules]="modules()"
  (onInit)="onEditorCreated($event)"
  (onTextChange)="onContentChanged($event)">
</p-editor>
